import BaseFeature from '../../foundation/base/base';

class BlobStack extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.stackContainer = this.el.querySelector('[data-ref="blob-stack__container"');
		this.allBlocks = this.stackContainer.querySelectorAll('.m-blob-content');
		this.focusBlock();
	}


	focusBlock() {
		this.allBlocks.forEach((block) => {
			block.addEventListener('mouseover', () => {
				block.parentElement.classList.add(block.getAttribute('data-target'));
			});

			block.addEventListener('mouseout', () => {
				// eslint-disable-next-line no-param-reassign
				block.parentElement.className = 'o-blob-stack__container';
			});
		});
	}
}

export default BlobStack;
